/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Amal Sabu, Ujjwal Singh >

*/

const defaultState = {
  loading: false,
  reviewPatientslist: [],
  selectedReviewPatientList: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_REVIEW_PATIENTS": {
      return {
        ...state,
        selectedReviewPatientList: [],
        reviewPatientslist: action.payload.data,
      };
    }
    case "GET_REVIEW_PATIENTS_REJECTED": {
      return {
        ...state,
        selectedReviewPatientList: [],
        viewPatientslist: action.payload,
      };
    }
    case "SAVE_REVIEW_PATIENTS": {
      return {
        ...state,
        reviewPatientslist: action.payload?.data,
      };
    }
    // case "SELECTED_VIEW_PATIENT_LIST_DATA": {
    //   return {
    //     ...state,
    //     selectedViewPatientList: action.payload,
    //     loading: false,
    //     // errors: {},
    //   };
    // }
    default:
      return state;
  }
  return state;
};
